import { Col, Row } from "antd";
import React from "react";
import "./index.less";
import ServicesPublic from "src/pages/public/services";
import { ButtonC } from "src/shared/components";
import { useTranslation } from "react-i18next";
import arrowsvg from "src/shared/assets/svg/newDesign/home/arrowsvg.svg";

const Section02WhiteLable02 = () => {
  const { t } = useTranslation();

  return (
    <Row justify="center" className="Section02WhiteLable02Style">
      <Col xs={24} lg={23} style={{ textAlign: "center" }} className="serviceList">
        <ServicesPublic />
      </Col>
      <Col span={24} className="hideSection">
        <ButtonC className="btn">
          {t("All Services")} <img src={arrowsvg} alt="" />
        </ButtonC>
      </Col>
    </Row>
  );
};

export default Section02WhiteLable02;
